import React from 'react';
import Link from 'next/link';

import { useSelector } from 'store';

const RetailListService: React.FC = () => {
  const retails = useSelector(state => state.space.retails);

  return (
    <div className="cnts-wrap">
      <div className="retail-list">
        <div className="list-wrap">
          <ul>
            {retails.results &&
              retails.results.map(retail => (
                <li key={retail.id}>
                  <Link href={`/retail/${retail.id}`}>
                    <a>
                      <div className="info">
                        <strong>{retail.name}</strong>
                        <p>{retail.summary}</p>
                      </div>
                      <span
                        className="thumb"
                        style={{
                          backgroundImage: `url('${retail.representation_image}')`,
                        }}
                      />
                    </a>
                  </Link>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RetailListService;
